module.exports = __webpack_public_path__ + "img/case1.e7242135.png";